import fp from 'lodash/fp';

export const mapReducersFromConfigurations = (moduleName) => fp.flow(
  fp.map(
    ({ reducers: { reducer, request, success, failed }, action: { [moduleName]: { api, ...action } }, name }) => {
      var result = {}
      if (reducer) {
        result = {
          ...result,
          [action[name]().type]: reducer
        }
      }
      if (request) {
        result = {
          ...result,
          [api[name].request]: request
        }
      }
      if (success) {
        result = {
          ...result,
          [api[name].success]: success
        }
      }
      if (failed) {
        result = {
          ...result,
          [api[name].failed]: failed
        }
      }
      return result
    }
  ),
  fp.reduce(
    (prev, current) => ({
      ...prev,
      ...current
    }),
    {}
  )
)

/**
 * for actions not following the standard format
 * we put the linking logic in the configuration and simply combine the reducers here
 */
export const combineConfigurationReducers = fp.flow(
  fp.map('reducers'),
  fp.reduce(
    (prev, current) => ({
      ...prev,
      ...current
    }),
    {}
  )
)


// WEBPACK FOOTER //
// ./src/state/helpers/reducer.js